
import AlertBox from 'JS/components/AlertBox.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'InstallationQuoteError',
	components: {
		AlertBox
	},
	props: {
		message: { type: String, required: true },
	},
	setup() {
		return {
			reload() {
				window.location.reload();
			}
		};
	}
});
